import { useState, useCallback } from '@wordpress/element';
import { select, dispatch} from "@wordpress/data";
import { Autocomplete, TextField } from "@mui/material";
import { STORE_NAME } from "../store";
import apiFetch from '@wordpress/api-fetch';
import CircularProgress from '@mui/material/CircularProgress';

export const VerseAutocomplete = () => {
	const instructions = { title: 'חיפוש טקסט או מספר פסוק' };
	const [options, setOptions] = useState([instructions]);
	const [loading, setLoading] = useState(false);
	const urlParams = new URLSearchParams( window.location.search );
	const searchParam = urlParams.get( 'search' );
	if ( searchParam ) {
		dispatch( STORE_NAME ).setSearchTerm(searchParam);
	}
	const [value, setValue] = useState(searchParam ? { title: searchParam } : null);
	const [ searchTerm, setSearchTerm ] = useState("");

    
	const bookData = select(STORE_NAME).getBookData();

	const handleOnChange = useCallback((event, newValue) => {
		console.log(event);
		setValue(newValue);
		if (newValue && newValue.permalink) {
			window.location.href = newValue.permalink + '?search=' + searchTerm;
		} else if (!newValue) {
			const url = new URL(window.location);
			// Check if the search parameter exists and remove it.
			if (url.searchParams.has('search')) {
				url.searchParams.delete('search');
				window.history.replaceState({}, '', url);
				dispatch( STORE_NAME ).setSearchTerm("");
			}
		}
	}, [setValue, searchTerm]);

	const fetchSuggestions = useCallback( async (event, term) => {
		if ( ! term ) {
			setOptions( [ instructions ] );
			return;	
		}
		if ( term.length < 3 ) {
			setOptions( [ { title: 'מעט מידיי תווים' } ] );
			return;	
		}
		setSearchTerm(term);
		setLoading(true);
		try {
			const results = await apiFetch({
				path: `/bbt-israel/v1/search-verses?input=${encodeURIComponent(term)}&book=${encodeURIComponent(bookData.slug)}`,
				method: 'GET',
			});
			setOptions(results);
		} catch (error) {
			console.error('Error fetching verse suggestions:', error);
			setOptions([]);
		} finally {
			setLoading(false);
		}
	}, [ bookData.slug, setOptions, setLoading ]);

	return (
		<Autocomplete
			sx={{ 
				minWidth: { sm: '250px' }, 
				width: { xs: '100%', sm: 'auto' },
				'& .MuiAutocomplete-listbox': {
					maxWidth: 'none',
					width: 'max-content',
					minWidth: '100%'
				}
			}}
			value={value}
			options={options}
			getOptionLabel={(option) => option.title || ''}
			filterOptions={(x) => x}
			onInputChange={fetchSuggestions}
			onChange={handleOnChange}
			loading={loading}
			noOptionsText="לא נמצאו תוצאות"
			renderInput={(params) => {
				return (
					<TextField 
						{...params} 
						label="חיפוש" 
						size="small"
						variant="outlined"
						InputProps={{
							...params.InputProps,
							style: { border: 'none', height: '40px' },
							sx: { 
								'& input': { border: 'none' },
							},
							endAdornment: (
								<>
									{loading ? <CircularProgress color="inherit" size={20} /> : null}
									{params.InputProps.endAdornment}
								</>
							)
						}}
					/>
				);
			}}
			renderOption={(props, option) => (
				<li {...props} value={option.permalink}>
					{option.title}
				</li>
			)}
		/>
	);
}